import type { CoachSpotlightRect } from './tutorialDemonstracaoCoachSpotlight';
import { COACH_SPOTLIGHT_RADIUS_PX } from './tutorialDemonstracaoCoachSpotlight';

type Props = {
	maskId: string;
	/** Buracos no escurecimento (alvos em destaque + header, quando aplicável). */
	holes: CoachSpotlightRect[];
};

const TutorialDemonstracaoCoachBackdrop = ({ maskId, holes }: Props) => (
	<svg className="pointer-events-none absolute inset-0 size-full" aria-hidden>
		<defs>
			<mask id={maskId}>
				<rect width="100%" height="100%" fill="white" />
				{holes.map((hole) => (
					<rect
						key={`${hole.top}-${hole.left}-${hole.width}-${hole.height}`}
						x={hole.left}
						y={hole.top}
						width={hole.width}
						height={hole.height}
						rx={COACH_SPOTLIGHT_RADIUS_PX}
						fill="black"
					/>
				))}
			</mask>
		</defs>
		<rect
			width="100%"
			height="100%"
			fill="rgba(0,0,0,0.55)"
			mask={`url(#${maskId})`}
		/>
	</svg>
);

export { TutorialDemonstracaoCoachBackdrop };
